import * as React from 'react';
import * as Features from '../../../../shared/Features';
import { Button, ButtonGroup } from 'react-bootstrap';
import { Translate } from '../../../../shared/LanguageService';

interface IProps {
    storeyName: string;
    filename: string;
    isLocked: boolean;
    user: any;
    imageSource: string;
    onClickImage: () => void;
    annotate: () => void;
    delete: () => void;
}

const DeliveryFile = (props: IProps) => {
    return (
        <fieldset>
            <legend>{props.storeyName}</legend>
            <div className="button-bar-below">
                <p className="limit-width">{props.filename}</p>
                <div className="content-row">
                    <img onClick={props.onClickImage} src={props.imageSource} />
                </div>

                {!props.isLocked && (
                    <div className="button-row">
                        <ButtonGroup bsSize="sm">
                            {Features.hasFeature(Features.AnnotateDeliveryFile, props.user) && (
                                <Button
                                    bsStyle="info"
                                    title={Translate('order/plan/delivery-file/annotate-button')}
                                    onClick={props.annotate}
                                >
                                    <i className="material-icons no-label">mode_edit</i>
                                </Button>
                            )}
                            {Features.hasFeature(Features.DeleteDeliveryFile, props.user) && (
                                <Button
                                    bsStyle="danger"
                                    title={Translate('order/plan/delivery-file/delete-button')}
                                    onClick={props.delete}
                                >
                                    <i className="material-icons no-label md-18">delete_forever</i>
                                </Button>
                            )}
                        </ButtonGroup>
                    </div>
                )}
            </div>
        </fieldset>
    );
};

export default DeliveryFile;
